import { Box, Stack, SxProps, Typography } from '@mui/material'
import Avatar, { AvatarProps } from '@mui/material/Avatar'
import { C1Icon } from 'components/core/icons/C1Icon'
import { Search } from 'lucide-react'
import { ReactNode } from 'react'

export interface EmptyListProps {
    text?: ReactNode
    title?: ReactNode
    icon?: ReactNode
    iconSize?: Pick<AvatarProps, 'sizes'>
    isError?: boolean
    direction?: 'column' | 'row'
    sx?: SxProps
}

export const EmptyList = ({ text, icon, title, isError, direction = 'column', sx }: EmptyListProps): React.ReactElement => {
    const message = text || 'There are no items.'

    return (
        <Box display="flex" gap={2} flexDirection={direction} alignItems="center" justifyContent={direction === 'row' ? 'flex-start' : 'center'} mt={5} mb={5} sx={sx}>
            <Avatar
                sx={{
                    width: '60px',
                    height: '60px',
                    fontSize: '30px',
                    borderColor: 'primary.light',
                    ...(isError ? { color: 'error.main', backgroundColor: 'error.extraLight' } : { color: 'primary.main', backgroundColor: 'primary.extraLight' }),
                    '& > .MuiSvgIcon-root': { fontSize: '30px' },
                }}
            >
                {icon || <C1Icon icon={Search} />}
            </Avatar>
            <Stack direction="column" alignItems={direction === 'row' ? 'flex-start' : 'center'} spacing={1}>
                {title && (
                    <Typography variant="h6" component="div" mt={3}>
                        {title}
                    </Typography>
                )}
                <Typography variant={title ? 'body1' : 'h6'} component="div" mt={2}>
                    {message}
                </Typography>
            </Stack>
        </Box>
    )
}
